// Single source of truth for "is this a dev build?" across the
// renderer. The main process appends `?dev=1` to the renderer URL
// when `!app.isPackaged`, so a URL search-param check is reliable
// and sync.
//
// Do not use location.hostname or port for this. The packaged app
// serves its renderer from 127.0.0.1 on the same port range as the
// dev server, so host-based checks give false positives and leak
// dev-only UI into shipped builds.

export function isDevBuild() {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('dev') === '1';
  } catch (_) { return false; }
}
